var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineInProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.193a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5zM.7 7.443a6.3 6.3 0 1112.6 0 6.3 6.3 0 01-12.6 0zm6.125-3.5c.29 0 .525.235.525.525v2.625h1.225a.525.525 0 010 1.05h-1.75a.525.525 0 01-.525-.525v-3.15c0-.29.235-.525.525-.525z",
    fill: "#fff"
  })));
}
export default SvgTimelineInProgress;